import { getJSON } from '../utils/fetchUtils'

export const getPlans = () => {
  return getJSON('/plans/')
}

export const getRanking = () => {
  return getJSON('/ranking-metadata/')
}

export const getCustomPricePlans = (applicationHashedId, currLocale = 'en') => {
  return getJSON(`/plans-custom-price/?hashed_id=${applicationHashedId}&locale=${currLocale}`)
}
